'use client'

import { variables } from '@/shared/styles/globals'
import { AntdRegistry } from '@ant-design/nextjs-registry'
import { ConfigProvider, message } from 'antd'
import { useTheme } from 'next-themes'
import React from 'react'

export function AntConfigProvider({ children }: {
  children: React.ReactNode;
}) {
  const { resolvedTheme } = useTheme()
  // resolvedTheme is undefined on the server and until next-themes mounts on the client -
  // this app forces light theme (forcedTheme="light", enableSystem={false} in layout.tsx),
  // so there's no real runtime choice to wait for. Defaulting here keeps the theme tokens fed
  // into ConfigProvider identical between server and client, avoiding an antd cssinjs
  // hydration mismatch (different theme tokens produce different generated style-hash classes).
  const getThemeVariables = variables[resolvedTheme ?? 'light']

  message.config({
    duration: 3,
  })

  return (
    <AntdRegistry>
      <ConfigProvider theme={getThemeVariables}>
        {children}
      </ConfigProvider>
    </AntdRegistry>
  )
}
